import React, { useState } from "react";
import { Input, Button } from "@public/ui-toolkit";
import CustomAlerts from "../CustomAlerts";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useRoles } from "../PermissionGate";
import PhoneInputComponent from "../PhoneInputComponent";

const CreateUser = ({ onSubmit, loading, message, roles }) => {
  const { workEmail } = useRoles();
  const [userProfileImage, setUserProfileImage] = useState();
  const [phoneNumber, setPhoneNumber] = useState("");
  const [roleName, setRoleName] = useState('');
  const phoneRegExp = /^[0-9]{10,16}$/;
  const passwordRegExp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

  const formik = useFormik({
    initialValues: {
      name: "",
      surname: "",
      emailAddress: "",
      city: "",
      state: "",
      address: "",
      phoneNumber: "",
      password: "",
      roleNames: "",
    },
    // enableReinitialize: true,
    validationSchema: Yup.object({
      name: Yup.string().required("Please enter your name."),
      surname: Yup.string().required("Please enter your surname."),
      emailAddress: Yup.string()
        .email("Please input valid email")
        .required("Please enter your email address.")
        .test(
          "email-include-domain",
          `Email Must include domain \'${workEmail.split("@")[1]} \'`,
          (value) => {
            if (value?.includes('@')) {
              return value.split("@")[1].toLowerCase() ===
                workEmail.split("@")[1].toLocaleLowerCase()
            }
            return false;
          }
        ),
      password: Yup.string()
        .matches(passwordRegExp,
          "Minimum 8 characters, at least 1 uppercase, 1 lowercase, 1 number and 1 special character required")
        .required("Please enter your password."),
      phoneNumber: Yup.string()
        .matches(phoneRegExp, "Phone number is not valid"),
        // .required("Please enter your phone number"),
      roleNames: Yup.string().required("Please select a role"),
    }),

    onSubmit: (values) => {
      const newValues = {
        ...values,
        profileImage: userProfileImage,
        phoneNumber: values?.phoneNumber?.length > 3 ? values?.phoneNumber : "",
      };
      const formData = new FormData();
      Object.keys(newValues).map((item) =>
        formData.append(`${item}`, newValues[`${item}`])
      );
      onSubmit(formData);
    },
  });

  const handleProfileImageChange = (e) => {
    var reader = new FileReader();
    reader.onload = function () {
      var output = document.getElementById("output_image");
      output.src = reader.result;
    };
    setUserProfileImage(e.target.files[0]);
    reader.readAsDataURL(e.target.files[0]);
  };

  return (
    <main>
      <div className="main-inner mt-5">
        {message && !loading ? (
          <CustomAlerts alertMessage={"Updated Successfully!"} type="success" />
        ) : (
          ""
        )}
        <div className="container">
          <div
            className="
            edit-profile-container
            p-xxl-5 p-md-4 p-3
            box-shadow
            bg-white
            rounded-large"
          >
            <div className="box-lg mt-5">
              <div className="edit-profile-picture mx-auto">
                <img
                  id="output_image"
                  src={"./assets/images/empty-avatar.png"}
                  alt="profile-img"
                />

                <div className="edit-btn">
                  <Input
                    type="file"
                    onChange={handleProfileImageChange}
                    name="image"
                    accept="image/*"
                    props
                  ></Input>
                </div>
              </div>
              <div className="mt-5">
                <div className="row g-4">
                  <div className="col-md-6">
                    <Input
                      type="text"
                      placeholder="Fist Name"
                      id="name"
                      label="First Name"
                      forr="name"
                      props
                      {...formik.getFieldProps("name")}
                    />
                    {formik.touched.name && formik.errors.name ? (
                      <div className="form-error-message">
                        {formik.errors.name}
                      </div>
                    ) : null}
                  </div>

                  <div className="col-md-6">
                    <Input
                      type="text"
                      placeholder="Last Name"
                      id="surname"
                      label="Last Name"
                      forr="surname"
                      props
                      {...formik.getFieldProps("surname")}
                    />
                    {formik.touched.surname && formik.errors.surname ? (
                      <div className="form-error-message">
                        {formik.errors.surname}
                      </div>
                    ) : null}
                  </div>
                  <div className="col-md-6">
                    <Input
                      type="email"
                      placeholder="Email Address"
                      id="email-address"
                      label="Email Address"
                      forr="email-address"
                      props
                      {...formik.getFieldProps("emailAddress")}
                    />
                    {formik.touched.emailAddress &&
                      formik.errors.emailAddress ? (
                      <div className="form-error-message">
                        {formik.errors.emailAddress}
                      </div>
                    ) : null}
                  </div>
                  <div className="col-md-6 phone-col">
                    <PhoneInputComponent
                      country={"us"}
                      placeholder="Phone Number"
                      value={phoneNumber}
                      onChange={(phone) => {
                        formik.setFieldValue("phoneNumber", phone);
                        setPhoneNumber(`+${phone}`);
                      }}
                    />
                    {formik.touched.phoneNumber && formik.errors.phoneNumber ? (
                      <div className="form-error-message">
                        {formik.errors.phoneNumber}
                      </div>
                    ) : null}
                  </div>
                  <div className="col-md-6 role-names">
                    <select
                      className={"form-select  field-white "}
                      {...formik.getFieldProps("roleNames")}
                      props
                    >
                      <option>
                        Role Names
                      </option>
                      {roles?.map((item, index) => {
                        return (
                          <option onChange={(role) => {
                            formik.setFieldValue("roleNames", role);
                            setRoleName(role);
                          }} key={index} value={item?.name}>
                            {item?.name}
                          </option>
                        );
                      })}
                    </select>
                    {formik.touched.roleNames && formik.errors.roleNames ? (
                      <div className="form-error-message">
                        {formik.errors.roleNames}
                      </div>
                    ) : null}
                  </div>
                  <div className="col-md-6">
                    <Input
                      type="password"
                      placeholder="Password"
                      id="password"
                      label="Password"
                      forr="Password"
                      props
                      {...formik.getFieldProps("password")}
                    />
                    {formik.touched.password && formik.errors.password ? (
                      <div className="form-error-message">
                        {formik.errors.password}
                      </div>
                    ) : null}
                  </div>

                  <div className="col-md-6">
                    <Input
                      type="text"
                      placeholder="State"
                      id="state"
                      label="State"
                      forr="state"
                      props
                      {...formik.getFieldProps("state")}
                    />
                  </div>
                  <div className="col-md-6">
                    <Input
                      type="text"
                      placeholder="City"
                      id="city"
                      label="City"
                      forr="city"
                      props
                      {...formik.getFieldProps("city")}
                    />
                  </div>
                  <div className="col-md-12">
                    <Input
                      type="text"
                      placeholder="Address"
                      id="address"
                      label="Address"
                      forr="address"
                      props
                      {...formik.getFieldProps("address")}
                    />
                  </div>
                </div>
                <div className="text-center mt-5">
                  <Button
                    btnName="Save"
                    type="submit"
                    btnType="primary"
                    onClick={formik.handleSubmit}
                    loading={loading}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default CreateUser;
